var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
import { runtime } from '../../Runtime';
import { localStore } from '../../../../utils/mobx/localStorage/MobxLocalStorage';
export class BrowserMediaDevices {
    parent;
    mediaDevices = observable.array();
    areMediaDevicesInitialized = false;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        this.initalizeDevices();
    }
    async initalizeDevices() {
        const mediaDevices = await navigator.mediaDevices.enumerateDevices();
        runtime.runtimeScheduler.addToNextStateChange(() => {
            this.mediaDevices.replace(mediaDevices);
            this.areMediaDevicesInitialized = true;
        });
    }
    get videoInputIndex() {
        const s = localStore.getItem('videoInputIndex');
        if (!s)
            return 0;
        const i = parseInt(s);
        if (i >= this.videoInputDevices.length)
            return 0;
        return i;
    }
    get audioInputIndex() {
        const s = localStore.getItem('audioInputIndex');
        if (!s)
            return 0;
        const i = parseInt(s);
        if (i >= this.audioInputDevices.length)
            return 0;
        return i;
    }
    get audioOutputIndex() {
        const s = localStore.getItem('audioOutputIndex');
        if (!s)
            return 0;
        const i = parseInt(s);
        if (i >= this.audioOutputDevices.length)
            return 0;
        return i;
    }
    get videoInputDevices() {
        return this.mediaDevices.filter((d) => d.kind === 'videoinput');
    }
    get audioInputDevices() {
        return this.mediaDevices.filter((d) => d.kind === 'audioinput');
    }
    get audioOutputDevices() {
        return this.mediaDevices.filter((d) => d.kind === 'audiooutput');
    }
    get currentVideoInputDevice() {
        if (this.videoInputDevices.length === 0)
            return undefined;
        return this.videoInputDevices[this.videoInputIndex];
    }
    get currentAudioInputDevice() {
        if (this.audioInputDevices.length === 0)
            return undefined;
        return this.audioInputDevices[this.audioInputIndex];
    }
    get currentAudioOutputDevice() {
        if (this.audioOutputDevices.length === 0)
            return undefined;
        return this.audioOutputDevices[this.audioOutputIndex];
    }
}
__decorate([
    observable.shallow
], BrowserMediaDevices.prototype, "mediaDevices", void 0);
__decorate([
    observable
], BrowserMediaDevices.prototype, "areMediaDevicesInitialized", void 0);
